<template>
    <div class="af" >
        <el-table ref="table" size="mini" border :data="formData" height="380" style="width: 100%" class="marT10"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="highlightCurrentRow">
                    <el-table-column prop="i_fypid" :label="$t('paymentApplication_cost_id')"></el-table-column>
                    <el-table-column prop="vc_no" :label="$t('form_order_number')" ></el-table-column>
                    <el-table-column prop="vc_xcode" :label="$t('paymentApplication_sales_order_number')" ></el-table-column>
                    <el-table-column prop="vc_pzname" :label="$t('form_product_name')" ></el-table-column>
                    <el-table-column prop="f_num" :label="$t('form_quantity')"  align="right"></el-table-column>
                    <el-table-column prop="f_pay" :label="$t('form_amount')"  align="right"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" style="text-align: center">
                <el-button @click="cancelDialog" size="mini">{{$t('button_cancel')}}</el-button>
            </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {

        },
        props:{
            data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                baseerp:"",
                highlightCurrentRow:false,
                formData:[],
            }
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.fkmxDetail(this.data)
        },
        methods:{

            cancelDialog(){
                this.$emit('cancelDialog')
            },

            async fkmxDetail(row){
                this.loading=true;
                let param={
                    i_id:row.i_id
                };
                var res = await API.fkmxDetail(param);
                if (res.code==1){
                    this.formData=res.data.list
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

        }
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table th .el-checkbox{
       display: none !important;
    }

    /deep/.el-table td{
        text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
